export default [
  {
    name: 'configuration',
    showInProduction: true,
    children: [
      {
        path: '/hotels',
        name: 'hotels',
        showInProduction: true,
        icon: 'location',
        availableforUsers: ['admin', 'owner', 'user'],
      },
      {
        path: '/pms',
        name: 'pms',
        showInProduction: true,
        icon: 'globo',
        onlyAdmin: 'true',
        availableforUsers: ['admin', 'owner'],
      },
      {
        path: '/checkin-config',
        name: 'configuration',
        showInProduction: true,
        icon: 'settings',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/guest-forms',
        name: 'forms',
        showInProduction: true,
        icon: 'list-interface-symbol',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/appearence',
        name: 'appearence',
        showInProduction: true,
        icon: 'pincel-de-artista',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/channels',
        name: 'sales',
        showInProduction: true,
        icon: 'checked',
        availableforUsers: ['admin', 'owner'],
      },
      {
        path: '/hcn',
        name: 'hcn',
        showInProduction: true,
        onlySuperUser: true,
        icon: 'checked',
        availableforUsers: ['admin', 'owner'],
      },
      {
        path: '/hbx-auto-invoice',
        name: 'hbxAutoInvoice',
        showInProduction: true,
        icon: 'checked',
        availableforUsers: ['admin', 'owner'],
        children: [
          {
            path: '/hbx-auto-invoice',
            name: 'hbxInvoiceData',
            showInProduction: true,
          },
          {
            path: '/hbx-upload-invoice',
            name: 'hbxuploadExampleInvoice',
            showInProduction: true,
          },
          {
            path: '/hbx-upload-templates',
            name: 'hbxuploadTemplate',
            showInProduction: true,
            onlySuperUser: true,
          },
        ],
      },
      {
        path: '/payment',
        name: 'payment',
        showInProduction: true,
        icon: 'tarjeta-de-credito',
        availableforUsers: ['admin', 'owner'],
      },
      {
        path: '/dooropening',
        name: 'doorOpening',
        showInProduction: true,
        icon: 'puerta',
        availableforUsers: ['admin', 'owner'],
        children: [
          {
            path: '/dooropening',
            name: 'doorOpeningConfig',
            showInProduction: true,
          },
          {
            path: '/door-maintenance',
            name: 'doorMapping',
            showInProduction: true,
          },
        ],
      },
      {
        path: '/police-report-config/integration',
        name: 'policeReportConfig',
        showInProduction: true,
        icon: 'police-report',
        availableforUsers: ['admin', 'owner', 'user'],
        children: [
          {
            path: '/police-report-config/integration',
            name: 'policeReportPlatform',
            showInProduction: true,
          },
          {
            path: '/police-report-config/PV',
            name: 'policeReportPV',
            showInProduction: true,
          },
          {
            path: '/police-report-config/RH',
            name: 'policeReportRH',
            showInProduction: true,
          },
        ],
      },
      {
        path: '/legal',
        name: 'documents',
        showInProduction: true,
        icon: 'equilibrar',
        availableforUsers: ['admin', 'owner', 'user'],
        children: [
          {
            path: '/legal/custom_cardex_pdf',
            name: 'custom_cardex_pdf',
            showInProduction: true,
          },
          {
            path: '/legal/cardex',
            name: 'cardex',
            showInProduction: true,
          },
          {
            path: '/legal/terms',
            name: 'terms',
            showInProduction: true,
          },
          {
            path: '/legal/data-privacy-policy',
            name: 'checkboxes',
            showInProduction: true,
            children: [
              {
                path: '/legal/data-privacy-policy',
                name: 'data-privacy-policy',
                showInProduction: true,
              },
              {
                path: '/legal/loyalty-program',
                name: 'loyalty-program',
                showInProduction: true,
              },
              {
                path: '/legal/data-commercial-use',
                name: 'data-commercial-use',
                showInProduction: true,
              },
            ],
          },
        ],
      },
      {
        path: '/sftp-checkin',
        name: 'SFTP',
        showInProduction: true,
        antdIcon: 'filePDF',
        availableforUsers: ['admin', 'owner'],
      },
      {
        path: '/informationTexts/startCheckin',
        name: 'infoText',
        showInProduction: true,
        antdIcon: 'textInfo',
        icon: '',
        availableforUsers: ['admin', 'owner', 'user'],
        children: [
          {
            path: '/informationTexts/startCheckin',
            name: 'startCheckin',
            showInProduction: true,
          },
          {
            path: '/informationTexts/legalDocuments',
            name: 'documents',
            showInProduction: true,
          },
          {
            path: '/informationTexts/endCheckin',
            name: 'endCheckin',
            showInProduction: true,
          },
        ],
      },
      // {
      //   path: '/communication-channels',
      //   name: 'communicationChannels',
      //   showInProduction: false,
      //   icon: 'megaphone',
      // },
      {
        path: '/guestlink',
        name: 'guestlink',
        showInProduction: true,
        icon: 'guestlink',
        availableforUsers: ['admin', 'owner', 'user'],
        children: [
          {
            path: '/guestlink',
            name: 'mailTemplates',
            showInProduction: true,
          },
          {
            path: '/guestlink-config',
            name: 'smtpConfig',
            showInProduction: true,
          },
        ],
      },
      {
        path: '/paperless-push',
        name: 'paperlessPush',
        showInProduction: true,
        //onlySuperUser: true,
        icon: 'paperless-push',
        availableforUsers: ['admin', 'owner'],
      },
    ],
  },
  {
    name: 'dashboard',
    showInProduction: true,
    children: [
      {
        path: '/stats',
        name: 'stats',
        showInProduction: true,
        icon: 'grafico',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/checkin',
        name: 'checkin',
        showInProduction: true,
        icon: 'tick',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/checkout',
        name: 'checkout',
        showInProduction: true,
        icon: 'checkout',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/booking',
        name: 'booking',
        showInProduction: true,
        icon: 'reserved',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/payments-list',
        name: 'paymentList',
        showInProduction: true,
        icon: 'tarjeta-de-credito',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/police-report/PV',
        name: 'policeReportList',
        showInProduction: true,
        icon: 'police-report',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
        children: [
          {
            path: '/police-report/PV',
            name: 'policeReportPV',
            showInProduction: true,
          },
          {
            path: '/police-report/RH',
            name: 'policeReportRH',
            showInProduction: true,
          },
        ],
      },
      {
        path: '/marketing',
        name: 'marketing',
        showInProduction: true,
        icon: 'bullseye',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/upsell',
        name: 'upsell',
        showInProduction: true,
        icon: 'upsell-icon',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
      {
        path: '/cross-sell',
        name: 'crossSell',
        showInProduction: true,
        icon: 'upsell-icon',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
    ],
  },
  {
    name: 'account',
    showInProduction: true,
    children: [
      {
        path: '/account-detail',
        name: 'accountDetail',
        showInProduction: true,
        icon: 'user',
        availableforUsers: ['admin', 'owner'],
      },
      {
        path: '/users',
        name: 'users',
        showInProduction: true,
        icon: 'star',
        availableforUsers: ['admin', 'owner'],
      },
      {
        path: '/billing',
        name: 'billingConfig',
        showInProduction: true,
        icon: 'tarjeta-de-credito',
        availableforUsers: ['admin', 'owner'],
      },
      {
        path: '/support',
        name: 'support',
        showInProduction: true,
        icon: 'support',
        availableforUsers: ['admin', 'owner', 'user', 'guest'],
      },
    ],
  },
];
